import React from 'react'
import './style.css'

export default ()=> (
    <div className='home_welcome'>
        <h2 className='header'>
            Bem vindo a área administrativa do site
            Caminho do Parque
        </h2>
        <span className='texto_corrido'>
            Aqui você poderá manipular e
            configurar os conteúdos disponíveis
            no site
        </span>
        <ul className='topicos_de_uso'>
            <li>Textos</li>
            <li>Imagens</li>
            <li>Informações institucionais</li>
            <li>Estado de vendas</li>
            <li>Perfis de pessoas autorizadas do aplicativo</li>
        </ul>
    </div>
)


// WEBPACK FOOTER //
// ./src/views/administrativo/home/component.js